<template>
    <div>
        <div class="form-group bmd-form-group is-filled">
            <label for="lead_type" class="bmd-label-floating">Tipo de Lead</label>
            <model-list-select
                class="form-control"
                :list="types"
                option-value="id"
                option-text="name"
                v-model="leadType"
                ></model-list-select>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                types: [
                    {id: '', name: '--'},
                    {id: 'active', name: "Leads Ativos"},
                    {id: 'new', name: "Leads Novos"},
                    {id: 'interaction', name: "Leads s/ Interação"},
                    {id: 'late', name: "Leads em Atraso"},
                    {id: 'schedule', name: "Leads Agendado"},
                    {id: 'lost', name: "Leads Perdido"},
                    {id: 'converted', name: "Leads Convertido"},
                ]
            };
        },
        mounted() {
            var self = this;
        },
        computed: {
            leadType: {
                set: function (_leadType) {
                    this.$emit("update-lead-type", _leadType);
                },
                get: function () {
                    return this.type;
                }
            }
        },
        props: {
            type: {
                required: true
            }
        }
    }
</script>
